const GOOGLE_FONT_STYLESHEETS: Readonly<Record<string, string>> = {
  'anton': 'https://fonts.googleapis.com/css2?family=Anton&display=swap',
  'nunito sans':
    'https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&display=swap',
  'exo 2': 'https://fonts.googleapis.com/css2?family=Exo+2:ital,wght@0,100..900;1,100..900&display=swap',
  'lato':
    'https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap',
  'montserrat': 'https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap',
  'libre franklin':
    'https://fonts.googleapis.com/css2?family=Libre+Franklin:ital,wght@0,100..900;1,100..900&display=swap',
  'oswald': 'https://fonts.googleapis.com/css2?family=Oswald:wght@200..700&display=swap',
  'roboto':
    'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
  'roboto condensed':
    'https://fonts.googleapis.com/css2?family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&display=swap',
  'signika': 'https://fonts.googleapis.com/css2?family=Signika:wght@300..700&display=swap',
  'francois one': 'https://fonts.googleapis.com/css2?family=Francois+One&display=swap',
  'mouse memoirs': 'https://fonts.googleapis.com/css2?family=Mouse+Memoirs&display=swap',
  'open sans': 'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap',
  'boogaloo': 'https://fonts.googleapis.com/css2?family=Boogaloo&display=swap',
  'source sans pro': 'https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600;700&display=swap',
  'passion one': 'https://fonts.googleapis.com/css2?family=Passion+One:wght@400;700;900&display=swap',
  'lilita one': 'https://fonts.googleapis.com/css2?family=Lilita+One&display=swap',
  'noto sans jp': 'https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;700&display=swap',
  'krub':
    'https://fonts.googleapis.com/css2?family=Krub:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;1,200;1,300;1,400;1,500;1,600;1,700&display=swap',
  'inter':
    'https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap',
};

const LOCAL_FONT_FAMILIES: ReadonlySet<string> = new Set([
  'curse casual',
  'lemon milk',
  'aller',
  'sofia pro',
  'sofiasans',
  'hp simplified',
  'neuron',
  'neuron demibold',
  'neuron heavy 2',
  'rifficfree',
  'riffic_freebold',
  'hvd comic serif pro',
  'dejavu sans',
  'nanum',
  'glober',
  'solomon sans default',
  'gilroy',
  'bubblegumbliss',
  'kingrobotoflex-regular',
  'lhfamericansansregular',
  'novemberhebrew',
  'font awesome 7 pro',
]);

const buildGenericGoogleFontHref = (fontName: string): string => {
  const familyParam = fontName
    .trim()
    .split(/\s+/)
    .map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`)
    .join('+');
  return `https://fonts.googleapis.com/css2?family=${familyParam}&display=swap`;
};

export const resolveGoogleFontHref = (fontName?: string | null): string | undefined => {
  if (!fontName) {
    return undefined;
  }

  const key = fontName.trim().toLowerCase();
  if (!key || LOCAL_FONT_FAMILIES.has(key)) {
    return undefined;
  }

  const curatedHref = GOOGLE_FONT_STYLESHEETS[key];
  if (curatedHref) {
    return curatedHref;
  }

  return buildGenericGoogleFontHref(fontName);
};

export const ALL_FONT_FAMILIES: ReadonlyArray<string> = [
  'Anton',
  'Boogaloo',
  'Exo 2',
  'Francois One',
  'Inter',
  'Krub',
  'Lato',
  'Libre Franklin',
  'Lilita One',
  'Montserrat',
  'Mouse Memoirs',
  'Noto Sans JP',
  'Nunito Sans',
  'Open Sans',
  'Oswald',
  'Passion One',
  'Roboto',
  'Roboto Condensed',
  'Signika',
  'Source Sans Pro',
  'Aller',
  'BubblegumBliss',
  'Curse Casual',
  'DejaVu Sans',
  'Font Awesome 7 Pro',
  'Gilroy',
  'Glober',
  'HP Simplified',
  'HVD Comic Serif Pro',
  'KingRobotoFlex-Regular',
  'Lemon Milk',
  'LHFAmericanSansRegular',
  'Nanum',
  'Neuron',
  'Neuron DemiBold',
  'Neuron Heavy 2',
  'NovemberHebrew',
  'RifficFree',
  'riffic_freebold',
  'Sofia Pro',
  'SofiaSans',
  'Solomon Sans Default',
];

export const resolveThemeFontHrefs = (
  fontNames: ReadonlyArray<string | undefined | null>,
): string[] => {
  const hrefs = fontNames
    .map((fontName) => resolveGoogleFontHref(fontName))
    .filter((href): href is string => Boolean(href));
  return Array.from(new Set(hrefs));
};
